import { LinkedPlanzone } from "./types";
import { HttpClient } from "../types/httpClient";
import { linkResources } from "../utils/linkResources";

function linkPlanzone(httpClient: HttpClient) {
  return (planzone: LinkedPlanzone): Promise<LinkedPlanzone> => {
    return linkResources(httpClient, planzone);
  };
}

export type { LinkedPlanzone };

export { linkPlanzone };
